import { render, staticRenderFns } from "./vodeoWriteI.vue?vue&type=template&id=bfc373fc&scoped=true"
import script from "./vodeoWriteI.vue?vue&type=script&lang=js"
export * from "./vodeoWriteI.vue?vue&type=script&lang=js"
import style0 from "./vodeoWriteI.vue?vue&type=style&index=0&id=bfc373fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc373fc",
  null
  
)

export default component.exports